import {
  NotificationsCLickInfo,
  NotificationsParam,
  NotificationsType,
  SysNotificationsEevnet,
} from '@/common/SysNotificationsDataDefine';
import EventEmitter from '@/common/EventEmitter';
import ipc, { IpcEvents } from './ipc';

class SysNotifications extends EventEmitter {
  init() {
    ipc.on(IpcEvents.CLICK_NOTIFICATIONS, this.onNotification);
  }

  unInit() {
    ipc.off(IpcEvents.CLICK_NOTIFICATIONS, this.onNotification);
  }

  private onNotification = (e: any, info: NotificationsCLickInfo) => {
    logger.ui.info('SysNotifications CLICK_NOTIFICATIONS', info);

    this.emit(SysNotificationsEevnet.EVENT_CLICK, info);
  };

  showNotifications(
    type: NotificationsType,
    title: string,
    body: string,
    subtitle = '',
    hideWhenForeground = false,
    extraData = '',
  ) {
    const info: NotificationsParam = {
      type,
      title,
      subtitle,
      body,
      hideWhenForeground,
      extraData,
    };
    ipc.send(IpcEvents.SHOW_NOTIFICATIONS, info);
  }
}

const sysNotifications = new SysNotifications();
export default sysNotifications;
